import { addStream } from '../../epicStore'
import { merge, fromEvent, Observable } from 'rxjs'
import { pluck, map, tap, mapTo } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import { TwilioUIDocInterface } from '../../../reducers/docs/types'
import { ReduxAction } from '../../../reducers/reducerType'
import { setUIState } from '../../../actions/docs/syncUi/syncUiActions'
import { handleUiDocRemovedEvent, docUIListenersAdded } from '../../../actions/docs/docsActions'

export const events$ = (doc: TwilioUIDocInterface) => merge(
  fromEvent<{ data: TwilioUIDocInterface['data'], isLocal?: boolean }>(doc, 'updated')
    .pipe(
      pluck('data'),
      map(docValue => setUIState(docValue))
    ),
  fromEvent(doc, 'removed')
    .pipe(
      map(() => handleUiDocRemovedEvent())
    )
)

const addUIEvents$ = (actions$) => actions$.pipe(
  ofType(actionTypes.SET_UI_DOCUMENT),
  pluck('payload'),
  map((doc: TwilioUIDocInterface) =>
    events$(doc)
  ),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  mapTo(() => docUIListenersAdded())
)

export default addUIEvents$
